<ng-container *ngIf="product">
  <div class="product-template">
    <div
      class="container-xxl gx-0 gx-md-5 d-flex justify-content-between flex-column flex-lg-row"
    >
      <div>
        <app-image-gallery
          class="sticky pe-lg-4"
          [product]="product"
        ></app-image-gallery>
      </div>
      <app-meta [product]="product"></app-meta>
    </div>
  </div>
  <div [appStoryblok]="_editable" *ngFor="let blok of story?.content?.body">
    <ndc-dynamic
      *ngIf="components"
      [ndcDynamicComponent]="components[blok.component]"
      [ndcDynamicInputs]="blok"
    >
    </ndc-dynamic>
  </div>
  <ng-container *ngIf="product?.tags?.includes('personalise')">
    <div
      [appStoryblok]="_editable"
      *ngFor="let blok of theme?.content?.personalise"
    >
      <ndc-dynamic
        *ngIf="components"
        [ndcDynamicComponent]="components[blok.component]"
        [ndcDynamicInputs]="blok"
      >
      </ndc-dynamic>
    </div>
  </ng-container>
  @defer {
  <app-okendo [product]="product"></app-okendo>
  <div [appStoryblok]="_editable" *ngFor="let blok of theme?.content?.sign_off">
    <ndc-dynamic
      *ngIf="components"
      [ndcDynamicComponent]="components[blok.component]"
      [ndcDynamicInputs]="blok"
    >
    </ndc-dynamic>
  </div>
  } @placeholder {
  <div></div>
  } @defer {
  <app-drawer>
    <app-back-in-stock [product]="product"></app-back-in-stock>
  </app-drawer>
  } @placeholder {
  <div></div>
  }
</ng-container>
